import { useState, useEffect } from "react";
import InputAHSF from "../../../Components/InputAHSF";
import AllDropDownsAHSF from "../../../Components/AllDropDownsAHSF";
import TextAreaAHSF from "../../../Components/TextAreaAHSF";
import { useDispatch, useSelector } from "react-redux";
import { getAllCountryOfProjectImplementation } from "../../../Redux/Reducers/DropDownApplicationInformation";
import SharedDiv from "../../../Components/SharedDiv/SharedDiv";
import ProjectInformationPage from "../../../Containers/ProjectInformationPage";
import {
  GetProjectInformation,
  SetProjectInformation,
  UpdateInformationAboutProject,
  UpdateInformationAboutProjectt,
  ValidateProjectInformation,
} from "../../../Redux/Reducers/ProjectInformationPage/ProjectInformation";
import LoaderAHSF from "../../../Components/LoaderAHSF";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import { SetPersonalInformation } from "../../../Redux/Reducers/PersonalInformation";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import loadConfig from "../../../Services/apiService";
import PopupAHSF from "../../../Components/PopupAHSF";
import $ from "jquery";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../../Services/Account/EncryptionParams";

const ProjectInformationModule = ({ setTest }) => {
  const AppGuid = useParams();
  const dispatch = useDispatch();
  const [countryOfProjectImplementation, setCountryOfProjectImplementation] =
    useState([]);
  const state = useSelector((state) => {
    // Extracting data from Redux state
    return {
      countryOfProjectImplementation:
        state.dropDownApplicationInformation.countryOfProjectImplementation,
      ProjectInformation: state.ProjectInformation.ProjectInformation,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
      loadingGetProjectInformation:
        state.ProjectInformation.loadingGetProjectInformation,
      ProjectInformationValidate:
        state.ProjectInformation.ProjectInformationValidate,
      loadingProjectInformationValidate:
        state.ProjectInformation.loadingProjectInformationValidate,
      ProjectInformationValidate2: state.ProjectInformation,
      ActiveRound: state.ApplicationInformation.ActiveRound,
      UpdateInfoAboutProject: state.ProjectInformation.UpdateInfoAboutProject,
      loadingUpdateInfoAboutProject:
        state.ProjectInformation
          .ProjectInformationloadingUpdateInfoAboutProject,
    };
  });

  const navigate = useNavigate();
  // State for project information form data
  const [projectInformation, setProjectInformation] = useState({
    // projectNameTitle: state.ProjectInformation?.projectNameTitle,
    // whatIsProblemYouAreSolving:
    //   state.ProjectInformation?.whatIsProblemYouAreSolving,
    // listMainObjectivesAchieveWithThisFund:
    //   state.ProjectInformation?.listMainObjectivesAchieveWithThisFund,
    // oneSentencePitch: state.ProjectInformation?.oneSentencePitch,
    // nameCountryWhichProjectWillBeImplemented:
    //   state.ProjectInformation?.nameCountryWhichProjectWillBeImplemented,
    // informationAboutProject: state.ProjectInformation?.informationAboutProject,
    // aP_CountryOfProjectImplementationId:
    //   state.ProjectInformation?.aP_CountryOfProjectImplementationId,
    // aI_ApplicationInformationId:
    //   state.ApplicationInformation?.aI_ApplicationInformationId,

    ...state.ProjectInformation,
  });
  const [dataJsonObject, SetDataJsonObject] = useState();
  // State to manage the popup visibility
  const [isPopupOpenStatus, setisPopupOpenStatus] = useState(false);
  // State for JSON configuration data
  const dataJson = async () => {
    let jsonData = await loadConfig();
    SetDataJsonObject(jsonData);
    //console.log(jsonData, "jsonData");
  };

  // Fetching data when the component mounts

//to get data by id for project info

  useEffect(() => {
    dispatch(getAllCountryOfProjectImplementation());
    dispatch(
      GetProjectInformation(
        state.ApplicationInformation.aI_ApplicationInformationId ||
          decryptToken(AppGuid.AppGuid)
      )
    );
  }, []);

  // const SaveData = () => {
  //   //console.log(state.ProjectInformation, "add", projectInformation);

  //   UpdateInformationAboutProject(
  //     state.ProjectInformation?.informationAboutProject,
  //     projectInformation.projectNameTitle,
  //     projectInformation.oneSentencePitch,
  //     projectInformation.nameCountryWhichProjectWillBeImplemented,
  //     projectInformation.whatIsProblemYouAreSolving,
  //     projectInformation.listMainObjectivesAchieveWithThisFund,
  //     projectInformation.aP_CountryOfProjectImplementationId,
  //     projectInformation.aI_ApplicationInformationId
  //   );
  // };
  // Function to save project data
  const SaveDataPage = async (withValidate) => {
    const saved = await dispatch(
      UpdateInformationAboutProjectt(
        // state.ProjectInformation?.informationAboutProject,
        // projectInformation.projectNameTitle,
        // projectInformation.oneSentencePitch,
        // projectInformation.nameCountryWhichProjectWillBeImplemented,
        // projectInformation.whatIsProblemYouAreSolving,
        // projectInformation.listMainObjectivesAchieveWithThisFund,
        // projectInformation.aP_CountryOfProjectImplementationId,
        // projectInformation.aI_ApplicationInformationId
        {
          ...state.ProjectInformation,
        }
      )
    );
    //for validation
    if (withValidate == true && saved) {
      const validate = await dispatch(
        ValidateProjectInformation(
          state.ProjectInformation.aI_ApplicationInformationId
        )
      );
      //after validation ends it will update data and show popup
      if (validate.payload.length === 0) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "تم حفظ المعلومات بنجاح",
          showConfirmButton: false,
          timer: 1500,
          // width: "500px",
        });
        //move to next page
        navigate("/grants/InformationProject/TargetAudience");
      } else {
        setisPopupOpenStatus(true);
      }
    }
  };

  //console.log(state.ProjectInformationValidate2, "state");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setTest((prev) => ({ ...prev, [name]: value }));
  };

  // Update project information state when data is loaded


//set data in reducer after loading ends

  useEffect(() => {
    if (!state.loadingGetProjectInformation) {
      setProjectInformation({ ...state.ProjectInformation });
    }
  }, [state.loadingGetProjectInformation]);
  //change on reducer on any change on state
  useEffect(() => {
    dispatch(SetProjectInformation({ ...projectInformation }));
  }, [projectInformation]);
  //console.log(state.ProjectInformation, "add", projectInformation);


  const shouldDisableFields =!(
   //[,]
// مابقدر يعدل اذا ماكانت الدورة فعالة او managerالحالة قيد المراجة او الدخول من ال
state.ActiveRound ==
      state.ApplicationInformation?.aI_RoundYearId &&
    state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
    window.location.href.includes("manager") == false);
//render html after loading ends

  return (
    <>
      {!state.loadingGetProjectInformation ? (
        <>
          <ProjectInformationPage active={0} />
          <SharedDiv
            showTitle={true}
            titleName="معلومات عن المشروع "
            child={[
              <div className="form-grid">
                <InputAHSF
                  fieldsName="ProjectName"
                  show={true}
                  disabled={shouldDisableFields}
                  defaultValue={state.ProjectInformation?.projectNameTitle}
                  onChange={(e) => {
                    setProjectInformation({
                      ...projectInformation,
                      projectNameTitle: e.target.value,
                    });
                  }}
                  showValidationMessage={
                    state.ProjectInformationValidate
                      ? state.ProjectInformationValidate.includes("ProjectName")
                      : false
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />
                <AllDropDownsAHSF
                  fieldsName="countryProjectImplemented"
                  show={true}
                  disabled={shouldDisableFields}
                  arrayOoptionList={state.countryOfProjectImplementation}
                  KeyText={"countryOfProjectImplementationNameAr"}
                  KeyValue={"aP_CountryOfProjectImplementationId"}
                  dropdownType={"normal"}
                  defaultValue={
                    state.ProjectInformation
                      ?.aP_CountryOfProjectImplementationId
                  }
                  onChange={(e) => {
                    setProjectInformation({
                      ...projectInformation,
                      aP_CountryOfProjectImplementationId: e.target.value,
                    });
                  }}
                  showValidationMessage={
                    state.ProjectInformationValidate
                      ? state.ProjectInformationValidate.includes(
                          "countryProjectImplemented"
                        )
                      : false
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />
                <TextAreaAHSF
                  fieldsName="PleaseDescribeProject"
                  show={true}
                  disabled={shouldDisableFields}
                  defaultValue={state.ProjectInformation?.oneSentencePitch}
                  onChange={(e) => {
                    setProjectInformation({
                      ...projectInformation,
                      oneSentencePitch: e.target.value,
                    });
                  }}
                  showValidationMessage={
                    state.ProjectInformationValidate
                      ? state.ProjectInformationValidate.includes(
                          "PleaseDescribeProject"
                        )
                      : false
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />
                <TextAreaAHSF
                  fieldsName="WhatProblemAddressingReducingIimpactQuestion"
                  show={true}
                  disabled={shouldDisableFields}
                  defaultValue={
                    state.ProjectInformation?.whatIsProblemYouAreSolving
                  }
                  onChange={(e) => {
                    setProjectInformation({
                      ...projectInformation,
                      whatIsProblemYouAreSolving: e.target.value,
                    });
                  }}
                  showValidationMessage={
                    state.ProjectInformationValidate
                      ? state.ProjectInformationValidate.includes(
                          "WhatProblemAddressingReducingIimpactQuestion"
                        )
                      : false
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />
                <TextAreaAHSF
                  fieldsName="AHSObjectivesQuestion"
                  show={true}
                  disabled={shouldDisableFields}
                  defaultValue={
                    state.ProjectInformation
                      ?.listMainObjectivesAchieveWithThisFund
                  }
                  onChange={(e) => {
                    setProjectInformation({
                      ...projectInformation,
                      listMainObjectivesAchieveWithThisFund: e.target.value,
                    });
                  }}
                  showValidationMessage={
                    state.ProjectInformationValidate
                      ? state.ProjectInformationValidate.includes(
                          "AHSObjectivesQuestion"
                        )
                      : false
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />
              </div>,
            ]}
          />
          {!shouldDisableFields ? (
            <div className="containerButtonMAin">
              <ButtonAHSF
                type={"submitter"}
                onClick={() => {
                  SaveDataPage(false);
                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "تم حفظ المعلومات بنجاح",
                    showConfirmButton: false,
                    timer: 1500,
                    // width: "500px",
                  });
                }}
                disabled={false}
                title={"حفظ"}
                text={"حفظ"}
                show={true}
              />
              <ButtonAHSF
                type={"submitter"}
                onClick={() => {
                  SaveDataPage(true);
                }}
                disabled={false}
                title={"التالي"}
                text={"التالي"}
                show={true}
              />
            </div>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      )}
      <LoaderAHSF
        show={state.OneInformationAboutTheTargetGroupOfTheProjectloading}
      />
      <PopupAHSF
        isPopupOpenStatus={isPopupOpenStatus}
        isPopupOpenFunction={() => setisPopupOpenStatus(false)}
        forValidate={true}
        maxWidth="50%"
        title="يرجى تعبئة الحقول المطلوبة"
        componentBody={state.ProjectInformationValidate}
      />
    </>
  );
};

export default ProjectInformationModule;
